export default __webpack_public_path__ + "static/media/dollar-sign.fdfaf9c7.svg";